module.exports = __webpack_public_path__ + "static/media/spoonerism-task (14).3cf242d4.mp3";